<!--Copyright (c) 2024 FileCloud. All rights Reserved.-->
<template>
  <label
    class="checkbox"
    :aria-label="label || description"
    :class="{ [`disabled`]: disabled }"
  >
    <span class="invisible">{{ label || description }}</span>
    <input
      :id="id"
      type="checkbox"
      :checked="trueValue ? modelValue || checked : !(modelValue || checked)"
      :name="name"
      :aria-label="label"
      :aria-description="description"
      :tabindex="tabindex"
      :true-value="trueValue"
      :false-value="falseValue"
      @input="onInput"
      @change="onChange"
    />
    <span class="checkmark">
      <Icon family="fal" name="check" />
    </span>
  </label>
</template>

<script>
import Icon from './Icon';
import { v4 as uuid } from 'uuid';

export default {
  components: {
    Icon,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      type: Boolean,
      default: true,
    },
    falseValue: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [Boolean, Number],
      default: false,
    },
    name: {
      type: String,
      default: () => uuid(),
    },
    description: String,
    label: String,
    id: {
      type: String,
      default: () => uuid(),
    },
    tabindex: {
      type: String,
      default: '0',
    },
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    onInput(e) {
      this.$emit('update:modelValue', e.target.checked);
    },
    onChange(e) {
      this.$emit('change', e.target.checked);
    },
  },
};
</script>
